<template>
    <faq 
        :title="$prismic.asText(slice.primary.h3)" 
        :questions-and-answers="items" 
    />
</template>
<script>
import Faq from '@/components/Faq.vue';
export default {
    components: {
        Faq
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        items() {
            return this.slice.items
                .filter(item => this.$validateText(item.question) && this.$validateText(item.answer));
        }
    }
};
</script>